export default __webpack_public_path__ + "2aa580d31280906a777208d7795721d8.png";